(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-website"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pc-filter [data-filter]').forEach(button => {
button.addEventListener('click', () => {
const section = button.closest('.pc-materials');
section.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
section.querySelectorAll('[data-polymer]').forEach(card => {card.hidden = button.dataset.filter !== 'all' && card.dataset.polymer !== button.dataset.filter;});
});
});
const material = new URLSearchParams(window.location.search).get('material');
const materialInput = document.getElementById('pc-interest');
if (material && materialInput) materialInput.value = material.slice(0, 150);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-compounds"] && !Shopify.designMode) return;
  try {
    const filter=document.getElementById('pc-polymer');if(filter){filter.addEventListener('change',()=>{document.querySelectorAll('[data-polymer]').forEach(card=>{card.hidden=filter.value!=='all'&&card.dataset.polymer!==filter.value;});});}const gradeFinder=document.getElementById('pc-grade-finder');if(gradeFinder){const originals=Array.from(document.querySelectorAll('#catalog .pc-card'));const copy=document.getElementById('pc-finder-copy');let summary='';gradeFinder.addEventListener('submit',event=>{event.preventDefault();const polymer=document.getElementById('finder-polymer').value;const priority=document.getElementById('finder-priority').value;const process=document.getElementById('finder-process').value;const use=document.getElementById('finder-use').value.trim();const conditions=document.getElementById('finder-conditions').value.trim();const needsReview=priority==='custom'||process!=='injection';const indices={general:[1,4],impact:[2,5],stiff:[0,3]};const candidates=needsReview?[]:(indices[priority]||[]).map(i=>originals[i]).filter(card=>card&&(polymer==='both'||card.dataset.polymer===polymer));const target=document.getElementById('pc-finder-candidates');target.replaceChildren();candidates.forEach(card=>{const clone=card.cloneNode(true);clone.hidden=false;target.appendChild(clone);});document.getElementById('pc-finder-result-title').textContent=needsReview?copy.dataset.review:copy.dataset.results;document.getElementById('pc-finder-reason').textContent=needsReview?copy.dataset.reviewBody:copy.dataset[priority];summary=copy.dataset.summary+'\n'+use+'\n'+document.getElementById('finder-polymer').selectedOptions[0].text+' / '+document.getElementById('finder-priority').selectedOptions[0].text+' / '+document.getElementById('finder-process').selectedOptions[0].text+'\n'+conditions+'\n'+candidates.map(card=>card.querySelector('h3').textContent.trim()).join('; ');const results=document.getElementById('pc-finder-results');results.hidden=false;results.focus();});document.getElementById('pc-finder-discuss').addEventListener('click',()=>{const message=document.getElementById('pc-message');if(message)message.value=summary;});}
  } catch(e) { console.error(e); }
})();
})();
